import { apiClient } from '@/lib/api-client';
import type { Client, Currency } from '@/types';

export type { Client } from '@/types';

export interface CreateClientRequest {
  name: string;
  businessName?: string;
  type: 'business' | 'private';
  currency?: Currency;
  email?: string;
  vatNumber?: string;
  vatReverseCharge?: boolean;
  vatReverseChargeMessage?: string;
  street?: string;
  city?: string;
  zipCode?: string;
  country?: string;
  hourlyRate?: number;
  defaultTaxRate?: number;
  termsAndConditions?: string;
  contactInfo?: string;
  notes?: string;
}

export interface UpdateClientRequest {
  name?: string;
  businessName?: string;
  type?: 'business' | 'private';
  currency?: Currency;
  email?: string;
  vatNumber?: string;
  vatReverseCharge?: boolean;
  vatReverseChargeMessage?: string;
  street?: string;
  city?: string;
  zipCode?: string;
  country?: string;
  hourlyRate?: number;
  defaultTaxRate?: number;
  termsAndConditions?: string;
  contactInfo?: string;
  notes?: string;
}

export class ClientsService {
  /**
   * Get all clients
   */
  async getClients(): Promise<Client[]> {
    return await apiClient.get<Client[]>('/clients');
  }

  /**
   * Get a specific client by ID
   */
  async getClient(id: string): Promise<Client> {
    return await apiClient.get<Client>(`/clients/${id}`);
  }

  /**
   * Create a new client
   */
  async createClient(data: CreateClientRequest): Promise<Client> {
    return await apiClient.post<Client>('/clients', data);
  }

  /**
   * Update an existing client
   */
  async updateClient(id: string, data: UpdateClientRequest): Promise<Client> {
    return await apiClient.put<Client>(`/clients/${id}`, data);
  }

  /**
   * Delete a client
   */
  async deleteClient(id: string): Promise<void> {
    return await apiClient.delete<void>(`/clients/${id}`);
  }
}

export const clientsService = new ClientsService();
